// extracted by mini-css-extract-plugin
export default {"mapWrapper":"Map_mapWrapper__0zpXz","locationLabel":"Map_locationLabel__mEUrp"};